(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-popup"] && !Shopify.designMode) return;
  try {
    
  var mpopup = document.getElementById('mpopupBox');
  var mconfirm = document.getElementById('mconfirm');  
  var close = document.getElementsByClassName("close")[0];
  close.onclick = function() {
    mpopup.style.display = "none";
  };
  mconfirm.onclick = function() {
    mpopup.style.display = "none";
  };
  window.onclick = function(event) {
    if (event.target == mpopup) {
        mpopup.style.display = "none";
    }
  };

  if(localStorage.getItem('popState') != 'shown' ){
      document.getElementById('mpopupBox').style.display = "block";
      localStorage.setItem('popState','shown')
  }
  

  } catch(e) { console.error(e); }
})();
})();
